export default __webpack_public_path__ + "static/sleepy_jatin-7233dbf601cae35bd9c6046b3da5cba6.svg";